module.exports = __webpack_public_path__ + "static/media/checkout-new.fce2a177.png";